import "./_Header.scss";
import "./_HeaderMobile.scss";
import lkiLogo from "../Assets/Design/LKI-full-logo.png";
import vegitaBlack from "../Assets/Design/vegitaBlack.png";
import { useState } from "react";

function _Header({ isAuthenticated, setIsAuthenticated }) {
  const [optionShow, isOptionShow] = useState(false);

  const handleLogout = async () => {
    try {
      const res = await fetch(
        `${process.env.REACT_APP_BASE_URL}api/admin/logout`,
        {
          method: "POST",
          credentials: "include",
        }
      );
      const data = await res.json();
      if (data.success) {
        setIsAuthenticated(false); // ✅ update parent state
      }
    } catch (err) {
      console.error("Logout failed:", err);
    }
  };

  return (
    <header className="admin-header">
      <div className="admin-logo-wrapper">
        <img src={lkiLogo} />
      </div>
      {isAuthenticated && (
        <div
          className="admin-option-wrapper"
          onClick={() => isOptionShow(!optionShow)}
        >
          <img src={vegitaBlack} />
          <span>ADMIN </span>
          <span
            style={{
              transform: optionShow ? "rotate(180deg)" : "rotate(0deg)",
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              fill="white"
              viewBox="0 0 24 24"
            >
              <path d="M7 10l5 5 5-5z" />
            </svg>
          </span>

          {optionShow && (
            <ul
              className="dropdown-menu"
              style={{ display: optionShow ? "block" : "none" }}
            >
              <li onClick={handleLogout}>LOG OUT</li>
            </ul>
          )}
        </div>
      )}
    </header>
  );
}

export default _Header;
